// extracted by mini-css-extract-plugin
export var divider = "_ju-7";
export var itemsToggle = "_ju-8";
export var mergeModal = "_ju-1";
export var optionCard = "_ju-4";
export var radioGroup = "_ju-6";
export var radioOption = "_ju-0";
export var selected = "_ju-5";
export var shipmentOptions = "_ju-2";
export var tableOptions = "_ju-3";